module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmDeleteSubOrder":"Are you sure you want to remove the selected stretch?"},"no":{"confirmDeleteSubOrder":"Er du sikker på at du vil fjerne den valgte strekning?"}}')
  delete Component.options._Ctor
}
